/* ==========================================================================
   Review list — filter, sort and paginate the real review pool

   Reads LUVZ.reviewData (assets/js/reviews.js) and renders the list for the
   product named in data-reviews="<handle>". Nothing is invented here: a
   product with no reviews yet gets an honest empty state.
   ========================================================================== */

window.LUVZ = window.LUVZ || {};

LUVZ.reviewList = (function () {
  'use strict';

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  var STAR = '<svg class="rating__star" viewBox="0 0 24 24" fill="currentColor"' +
    ' aria-hidden="true"><path d="m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.9L12 17.8 5.8 21.1' +
    ' 7 14.2l-5-4.9 6.9-1z"/></svg>';
  var STAR_EMPTY = STAR.replace('rating__star"', 'rating__star rating__star--empty"');

  function stars(n) {
    var out = '';
    for (var i = 0; i < 5; i++) out += i < Math.round(n) ? STAR : STAR_EMPTY;
    return '<span class="rating" role="img" aria-label="' + n +
      ' out of 5 stars">' + out + '</span>';
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso + 'T00:00:00');
    if (isNaN(d)) return iso;
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  }

  function card(r) {
    var initial = (r.name || '?').trim().charAt(0).toUpperCase();
    var verified = r.verified
      ? '<span class="review-card__verified"><svg width="11" height="11" viewBox="0 0 24 24"' +
        ' fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true">' +
        '<path d="M20 6 9 17l-5-5"/></svg>Verified buyer</span>'
      : '';
    /* many titles are just the first words of the review; skip those */
    var norm = function (x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
    var title = r.title && norm(r.body).indexOf(norm(r.title)) !== 0
      ? '<p class="review-card__title">' + escapeHtml(r.title) + '</p>' : '';
    return '<li class="review-card">' +
      '<div class="review-card__head">' +
        '<span class="review-card__avatar" aria-hidden="true">' + escapeHtml(initial) + '</span>' +
        '<span class="review-card__author">' + escapeHtml(r.name) + '</span>' +
        stars(r.rating) + verified +
        '<time class="review-card__date" datetime="' + escapeHtml(r.date) + '">' +
          formatDate(r.date) + '</time>' +
      '</div>' + title +
      '<p class="review-card__body">' + escapeHtml(r.body) + '</p>' +
      '</li>';
  }

  function init() {
    var root = document.querySelector('[data-reviews]');
    if (!root || !LUVZ.reviewData) return;

    var data = LUVZ.reviewData[root.getAttribute('data-reviews')];
    var list = root.querySelector('.reviews__list');
    if (!list) return;

    var all = (data && data.reviews) || [];
    var empty = root.querySelector('[data-rev-empty]');
    var moreWrap = root.querySelector('.reviews__more');
    var moreN = root.querySelector('[data-rev-more-n]');
    var step = parseInt(root.getAttribute('data-rev-limit'), 10) || 6;
    var state = { filter: 'all', sort: 'new', shown: step };
    var autoScrollTimer;
    var autoScrollResumeTimer;

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 680px)').matches;
    }

    function stopAutoScroll() {
      window.clearInterval(autoScrollTimer);
      window.clearTimeout(autoScrollResumeTimer);
    }

    function startAutoScroll() {
      stopAutoScroll();
      if (!isMobile()) return;
      autoScrollTimer = window.setInterval(function () {
        var cards = list.querySelectorAll('.review-card');
        if (cards.length < 2) return;
        var current = Math.round(list.scrollLeft / Math.max(1, cards[0].offsetWidth));
        var next = current + 1;
        if (next >= cards.length) next = 0;
        list.scrollTo({ left: cards[next].offsetLeft, behavior: 'smooth' });
      }, 5000);
    }

    function pauseAutoScroll() {
      stopAutoScroll();
      autoScrollResumeTimer = window.setTimeout(startAutoScroll, 8000);
    }

    function filtered() {
      var out = all.filter(function (r) {
        if (state.filter === 'all') return true;
        if (state.filter === 'low') return r.rating <= 3;
        return r.rating === parseInt(state.filter, 10);
      });
      out.sort(function (a, b) {
        if (state.sort === 'high') return b.rating - a.rating;
        if (state.sort === 'low') return a.rating - b.rating;
        return (b.date || '').localeCompare(a.date || '');
      });
      return out;
    }

    function render() {
      var rows = filtered();
      var visible = rows.slice(0, state.shown);
      list.innerHTML = visible.map(card).join('');
      list.scrollLeft = 0;
      if (empty) empty.hidden = rows.length > 0;
      var remaining = rows.length - visible.length;
      if (moreWrap) moreWrap.hidden = remaining <= 0;
      if (moreN) moreN.textContent = Math.min(remaining, step);
    }

    root.addEventListener('click', function (e) {
      var f = e.target.closest('[data-rev-filter]');
      if (f) {
        state.filter = f.getAttribute('data-rev-filter');
        state.shown = step;
        root.querySelectorAll('[data-rev-filter]').forEach(function (b) {
          var on = b === f;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        render();
        return;
      }
      var s = e.target.closest('[data-rev-sort]');
      if (s) {
        state.sort = s.getAttribute('data-rev-sort');
        root.querySelectorAll('[data-rev-sort]').forEach(function (b) {
          var on = b === s;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        render();
        return;
      }
      if (e.target.closest('[data-rev-more]')) {
        state.shown += step;
        render();
      }
    });

    list.addEventListener('touchstart', pauseAutoScroll, { passive: true });
    list.addEventListener('pointerdown', pauseAutoScroll);
    window.addEventListener('resize', startAutoScroll);

    if (!all.length) {
      var tools = root.querySelector('.reviews__tools');
      if (tools) tools.hidden = true;
      if (moreWrap) moreWrap.hidden = true;
      if (empty) {
        empty.hidden = false;
        empty.textContent = 'No reviews yet — be the first to try it.';
      }
      return;
    }

    render();
    startAutoScroll();
  }

  return { init: init };
}());
